/* app/ui/listing/operator */

define(
	'app/ui/listing/operator',[
		'jquery',
		'util/core',
		'app/ui/listing/filter',
		'app/ui/listing/map',
		'app/ui/listing/pagination',
		'templayed',
		'text!templates/filtersummary.html',
		'text!templates/operatorlisting.html',
		'text!templates/pagination.html',
		'pubsub'
	],
	function ($, Core, Filter, Map, Pagination, templayed, summaryTemplate, listingTemplate, paginationTemplate) {

		window.dataLayer = window.dataLayer || [];

		var Module;

		var classes = {
			open: 'is-open'
		};

		var historySupport = window.history && window.history.pushState;

		var firstLoad = true;
		var fromHistory = false;
		var $listingContainer;
		var $filterSummaryContainer;
		var $operatorListContainer;
		var $paginationContainer;
		var baseJsonUrl;
		var feedData = {};
		var queryObj = {};
		var perPage = 10;

		return {
			init: function($elms) {

				Module = this;
				$listingContainer = $elms.eq(0);
				baseJsonUrl = $listingContainer.data('json-url');
				queryObj = Core.getQueryStringObject();

				// Remove "page" param
				queryObj.queryString = queryObj.queryString.replace(/(^|&)page=.*?(&|$)/, '$1');
				queryObj.filters = queryObj.filters.filter(function (el) {
					return el.filterName !== 'page';
				});

				summaryTemplate = summaryTemplate.replace(/\r/g, '');
				listingTemplate = listingTemplate.replace(/\r/g, '');
				paginationTemplate = paginationTemplate.replace(/\r/g, '');

				Filter.init($listingContainer, classes);
				Map.init($listingContainer, classes);
				Pagination.init($listingContainer);

				Module._initElements();
				Module._initSubscriptions();
				Module._initEvents();

				var firstFetchUrl = baseJsonUrl;
				if (baseJsonUrl !== '') {
					if (queryObj.queryString !== '') {
						if (firstFetchUrl.indexOf('?') !== -1) {
							firstFetchUrl += '&';
						} else {
							firstFetchUrl += '?';
						}
						firstFetchUrl += queryObj.queryString;
					}
					Module._fetchFeedData(firstFetchUrl);
				}
			},

			_initElements: function() {
				$filterSummaryContainer = $listingContainer.find('.js-summary-container');
				$operatorListContainer = $listingContainer.find('.js-operator-listing-container');
				$paginationContainer = $listingContainer.find('.js-pagination-container');
			},

			_initSubscriptions: function() {
				$.subscribe('/operator/listing/update', Module._initListing);
				$.subscribe('/pagination/update', Module._onPaginationUpdate);
				$.subscribe('/operator/listing/overlay', Module._toggleListingStatus);
			},

			_initEvents: function() {
				window.onpopstate = Module._processPopState;
				$listingContainer.on('mouseenter mouseleave', '.js-operator-tile', Module._handleOperatorMouseEvent);

				$listingContainer.on('click', '.js-gtm-operator-listing-detail', Module._trackDetailClick);
				$listingContainer.on('click', '.js-gtm-operator-listing-detail-feature', Module._trackDetailFeatureClick);

				$listingContainer.on('click', '.js-gtm-operator-listing-booking', Module._trackDetailBookClick);
				$listingContainer.on('click', '.js-gtm-operator-listing-booking-feature', Module._trackDetailFeatureBookClick);
			},

			_processPopState: function (event) {
				var state = event.state;

				if (state) {
					fromHistory = true;
					feedData = state.data;
					Filter.updateFilters(feedData.queryObj);
					Module._updateListing(state.data.pagination);
					$.publish('/operator/feed/loaded', [feedData]);
				}
			},

			// Update listing when new filters are applied
			_initListing: function(queryData) {
				queryObj = queryData;
				fromHistory = false;

				var queryChar = baseJsonUrl.indexOf('?') === -1 ? '?' : '&';

				var url = baseJsonUrl + queryChar + queryObj.queryString;
				Module._fetchFeedData(url);
			},

			// Fetch feed data from AjaxController
			_fetchFeedData: function (url) {
				$.ajax({
						url: url,
						dataType: 'json'
					})
					.done(
						Module._fetchFeedDataComplete
					)
					.fail(
						Module._fetchFeedDataError
					);
			},

			// Process feed data
			_fetchFeedDataComplete: function (data) {
				feedData = data;
				var hasResults = feedData.Count >= 1;
				var hasPagination = feedData.Count > perPage;

				if (firstLoad) {
					feedData.queryObj = Core.getQueryStringObject();
				} else {
					feedData.queryObj = queryObj;
				}

				feedData.hasPagination = hasPagination;
				feedData.hasResults = hasResults;
				feedData.noResults = !hasResults;
				feedData.pagination = Pagination.getPagingData(feedData);

				$.publish('/operator/feed/loaded', [feedData]);

				if (!firstLoad) {
					Module._updateListing(feedData.pagination);
				}

				if (firstLoad && historySupport) {
					history.replaceState({ data: feedData }, document.title, document.location);
					firstLoad = false;
				}
			},

			_fetchFeedDataError: function() {
				console.error('There was an error retrieving feed data.');
				// Remove map toggle
				// Unbind pagination / filtering events
			},

			_onPaginationUpdate: function (pagingData) {
				fromHistory = false;
				Module._updateListing(pagingData);
			},

			// Pagination updated
			// Get the new set of items to show
			// Construct a new summary object
			// Compile + inject listing template
			// Compile + inject summary template
			_updateListing: function (pagingData) {
				feedData.pagination = pagingData;

				var itemsToShow = feedData.Listings.slice(pagingData.pageStart - 1, pagingData.pageEnd);
				var summaryObj = {
					hasResults: pagingData.pageEnd > 0,
					pageStart: Math.min(pagingData.pageStart, pagingData.total).toString(),
					pageEnd: Math.min(pagingData.pageEnd, pagingData.total).toString(),
					total: pagingData.total.toString(),
					noResults: pagingData.pageEnd === 0,
					dropdownFilters: feedData.queryObj.dropdownFilters,
					inputFilters: feedData.queryObj.inputFilters,
					checkboxFilters: feedData.queryObj.checkboxFilters
				};

				var compiledSummary = templayed(summaryTemplate)(summaryObj);

				itemsToShow.forEach(function (item, index) {
					item.IconListShow = item.IconList.filter(function (icon) {
						return icon.cap;
					});
				});

				var compiledListing = templayed(listingTemplate)({ BookNowLabel: feedData.BookNowLabel, Listings: itemsToShow, HasListings: !!itemsToShow.length });
				var url = Module._constructHistoryUrl(pagingData.currentPage);

				$filterSummaryContainer.html(compiledSummary);
				$operatorListContainer.html(compiledListing);
				$paginationContainer.empty();

				if (pagingData.total > perPage) {
					var compiledPagination = templayed(paginationTemplate)(pagingData);
					$paginationContainer.html(compiledPagination);
				}

				if (historySupport && !fromHistory) {
					history.pushState({ data: feedData }, document.title, url);
				}

				Core.scrollToElm($listingContainer);
			},

			_handleOperatorMouseEvent: function(event) {
				var $tile = $(this);
				var action = event.type;

				$.publish('/operator/list/mouseevent', { tile: $tile, action: action });
			},

			_toggleListingStatus: function() {
				$listingContainer.toggleClass('has-overlay');
			},

			_constructHistoryUrl: function(currentPage) {
				var url = '';

				if (feedData.queryObj.queryString !== '') {
					url = '?' + feedData.queryObj.queryString;

					if (currentPage > 1) {
						var urlNoPage = url.replace(/(\?|&)page=.*?(&|$)/, '$1');
						var queryChar = urlNoPage !== '?' ? '&' : '';

						url = urlNoPage + queryChar + 'page=' + currentPage;
					}
					return url;
				}

				return currentPage > 1 ? '?page=' + currentPage : document.location.pathname;
			},

			_trackDetailClick: function (e) {
				var $link = $(e.target);
				var operatorName = $link.text() || $link.data('operator-name');

				window.dataLayer.push({
					'event': 'customEvent',
					'eventDetails': {
						'category': 'Operator Listing',
						'action': 'View Detail',
						'label': 'Operator: ' + operatorName + ', Page: ' + document.location.href
					}
				});
			},
			_trackDetailFeatureClick: function (e) {
				var $link = $(e.target);
				var operatorName = $link.text() || $link.data('operator-name');

				window.dataLayer.push({
					'event': 'customEvent',
					'eventDetails': {
						'category': 'Operator Listing',
						'action': 'Feature View Detail',
						'label': 'Operator: ' + operatorName + ', Page: ' + document.location.href
					}
				});
			},

			_trackDetailBookClick: function (e) {
				var $link = $(e.target);
				var operatorName = $link.text() || $link.data('operator-name');

				if ($link.hasClass('js-book-btn')) {
					operatorName = $link.data('operator-name');
				}

				window.dataLayer.push({
					'event': 'customEvent',
					'eventDetails': {
						'category': 'Operator Listing',
						'action': 'Booking',
						'label': 'Operator: ' + operatorName + ', Page: ' + document.location.href
					}
				});
			},
			_trackDetailFeatureBookClick: function (e) {
				var $link = $(e.target);
				var operatorName = $link.text() || $link.data('operator-name');

				if ($link.hasClass('js-book-btn')) {
					operatorName = $link.data('operator-name');
				}

				window.dataLayer.push({
					'event': 'customEvent',
					'eventDetails': {
						'category': 'Operator Listing',
						'action': 'Feature Booking',
						'label': 'Operator: ' + operatorName + ', Page: ' + document.location.href
					}
				});
			}
		};
	}
);
